// Helpers
import { hashLowerCaseString } from "./strings";

/**
 * Event base data.
 */
const EVENT_BASE_DATA = {
    event: undefined
};

/**
 * Event user related data.
 */
const EVENT_USER_DATA = {
    user_id: undefined,
    user_email: undefined,
    user_role: undefined,
    user_name: undefined
};

/**
 * Event custom data.
 */
const EVENT_CUSTOM_DATA = {
    timestamp: undefined,
    meeting_link: undefined,
    report_name: undefined,
    report_link: undefined,
    activity_name: undefined,
    activity_link: undefined,
    start_timestamp: undefined,
    end_timestamp: undefined,
    test_type: undefined,
    patient_name: undefined,
    booking_start_timestamp: undefined,
    booking_therapist_name: undefined,
    booking_therapist_email: undefined
};

/**
 * Event data.
 */
const EVENT_OBJ = {
    ...EVENT_BASE_DATA,
    ...EVENT_USER_DATA,
    ...EVENT_CUSTOM_DATA
};

/**
 * Triggers a GTM custom event.
 *
 * @param {String} eventName the custom event name
 * @param {Object} data custom event data
 */
export const triggerCustomEvent = (eventName, data) => {
    if (data?.user_email?.length > 0) {
        data.user_id = hashLowerCaseString(data.user_email);
    }

    if (window && window.dataLayer) {
        window.dataLayer.push({
            ...EVENT_OBJ,
            event: eventName,
            timestamp: new Date().toISOString(),
            ...data
        });

        window.dataLayer.push(function () {
            Object.keys(EVENT_CUSTOM_DATA).forEach(key => {
                this.set(key, undefined);
            });
        });
    }
};

/**
 * Triggers an enter app / login GTM custom event.
 *
 * @param {Object} data current user's data
 */
export const triggerEnterAppEvent = data => {
    triggerCustomEvent("login", data);
};

/**
 * Triggers a report access GTM custom event.
 *
 * @param {Object} data current user's and report data
 */
export const triggerAccessReportEvent = data => {
    triggerCustomEvent("access_report", data);
};

/**
 * Triggers a meeting link access GTM custom event.
 *
 * @param {Object} data current user's and meeting link data
 */
export const triggerAccessMeetingLinkEvent = data => {
    triggerCustomEvent("access_meeting_link", data);
};

/**
 * Triggers an activity access GTM custom event.
 *
 * @param {Object} data current user's and activity data
 */
export const triggerAccessActivityEvent = data => {
    triggerCustomEvent("access_activity", data);
};

/**
 * Triggers a create test GTM custom event.
 *
 * @param {Object} data current user's and test related data
 */
export const triggerCreateTestEvent = data => {
    triggerCustomEvent("create_test", data);
};

/**
 * Triggers a delete booking/session GTM custom event.
 *
 * @param {Object} data current user's and booking/session related data
 */
export const triggerDeleteBookingEvent = data => {
    triggerCustomEvent("delete_booking", data);
};
